import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { HttpService } from '../shared/services/http.service';
import { GatewayId } from '../site-gateway/models/gateway';

interface Toolbox {
    gatewayId: GatewayId;
    qrCode: string;
}

@Injectable({ providedIn: 'root' })
export class ToolboxGateway {
    private readonly httpService = inject(HttpService);

    async getToolboxes(): Promise<readonly GatewayId[]> {
        const toolboxes = await firstValueFrom<Toolbox[] | null>(this.httpService.get('/v1/toolbox'));

        return (toolboxes ?? []).map(({ gatewayId }) => gatewayId);
    }
}
